import React, { useEffect, useState } from 'react'
import '../../../Assets/Css/AddAward.scss'
import { customStyle } from '../../../Components/Style'
import Select from 'react-select'
import { connect } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import { addAward, updateAward } from '../../../Services/Award/action';
import DatePicker from 'react-datepicker';
import { updateSalarySlip } from '../../../Services/Salary/action'
import { Month, Year } from '../../../Lib/utils'
import { IoMdAddCircleOutline } from 'react-icons/io';
import { MdOutlineRemoveCircleOutline } from "react-icons/md";

const EditEmpSalarySlips = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const data = location?.state?.data?.allData;
    const salaryDetail = data?.salary_details?.[0] || {};
    const earnings = salaryDetail.earning || {};
    const deductions = salaryDetail.deduction || {};

    const standardEarningFields = [
        'basic_salary', 'da', 'house_rent_allowance', 'ma', 'special_allowance', 'bonus'
    ];
    const standardDeductionFields = [
        'leave', 'incomeTax', 'providentFund'
    ];

    const getExtraFields = (allFields, standardFields) => {
        return Object.keys(allFields)
            .filter(key => !standardFields.includes(key) && key !== 'bonus ')
            .map(key => ({
                name: key,
                value: allFields[key] || ''
            }));
    };

    const initialState = {
        transaction_id: data?.transaction_id || '',
        pay_period_month: Month?.find(item => item?.value == data?.pay_period?.split(" ")?.[0]) || null,
        pay_period_year: Year?.find(item => item?.value == data?.pay_period?.split(" ")?.[1]) || null,
        pay_date: data?.pay_date || null,
        day: data?.day || '',
        loss_pay_day: data?.loss_pay_day || 0,
        name: data?.name || '',
        employee_id: data?.employee_id || '',
        basic_salary: earnings.basic_salary || '',
        da: earnings.da || '',
        house_rent_allowance: earnings.house_rent_allowance || '',
        ma: earnings.ma || '',
        special_allowance: earnings.special_allowance || '',
        bonus: earnings['bonus '] || earnings.bonus || '',
        leave: deductions.leave || '',
        incomeTax: deductions.incomeTax || '',
        providentFund: deductions.providentFund || '',
        extraEarnings: getExtraFields(earnings, [...standardEarningFields, 'bonus ']),
        extraDeductions: getExtraFields(deductions, standardDeductionFields)
    }

    const [clientData, setClientData] = useState(initialState);
    const calculateEarnings = () => {
        const standardEarnings = standardEarningFields.reduce((total, field) => {
            return total + (parseFloat(clientData[field]) || 0);
        }, 0);

        const extraEarnings = (clientData.extraEarnings || []).reduce((total, field) => {
            return total + (parseFloat(field.value) || 0);
        }, 0);

        return standardEarnings + extraEarnings;
    };

    const calculateDeductions = () => {
        const standardDeductions = standardDeductionFields.reduce((total, field) => {
            return total + (parseFloat(clientData[field]) || 0);
        }, 0);

        const extraDeductions = (clientData.extraDeductions || []).reduce((total, field) => {
            return total + (parseFloat(field.value) || 0);
        }, 0);

        return standardDeductions + extraDeductions;
    };

    const calculateNetPay = () => {
        return calculateEarnings() - calculateDeductions();
    };

    const handleUpdateSalarySlip = async () => {
        try {
            const earningsObject = {
                basic_salary: parseFloat(clientData?.basic_salary) || 0,
                da: parseFloat(clientData?.da) || 0,
                house_rent_allowance: parseFloat(clientData?.house_rent_allowance) || 0,
                ma: parseFloat(clientData?.ma) || 0,
                special_allowance: parseFloat(clientData?.special_allowance) || 0,
                'bonus ': parseFloat(clientData?.bonus) || 0,
            };

            (clientData.extraEarnings || []).forEach(field => {
                if (field.name && field.value) {
                    earningsObject[field.name] = parseFloat(field.value) || 0;
                }
            });

            const deductionsObject = {
                leave: parseFloat(clientData?.leave) || 0,
                incomeTax: parseFloat(clientData?.incomeTax) || 0,
                providentFund: parseFloat(clientData?.providentFund) || 0,
            };

            (clientData.extraDeductions || []).forEach(field => {
                if (field.name && field.value) {
                    deductionsObject[field.name] = parseFloat(field.value) || 0;
                }
            });

            const body = {
                transaction_id: clientData?.transaction_id,
                pay_period: `${clientData?.pay_period_month?.value || ''} ${clientData?.pay_period_year?.value || ''}`.trim(),
                pay_date: clientData?.pay_date,
                day: clientData?.day,
                loss_pay_day: clientData?.loss_pay_day,
                name: clientData?.name,
                employee_id: clientData?.employee_id,
                total_pay: calculateNetPay().toFixed(2),
                salary_details: [{
                    earning: earningsObject,
                    deduction: deductionsObject
                }]
            }
            await props?.updateSalarySlip(data?.id, body);
            navigate(-1);
        } catch (error) {
            console.error("Error updating salary slip details : ", error)
        }
    }

    const handleInputChange = (field, value) => {
        setClientData((preVal) => ({
            ...preVal,
            [field]: value
        }));
    };

    const handleExtraChange = (section, index, key, value) => {
        setClientData((prev) => {
            const updatedFields = [...prev[section]];
            updatedFields[index][key] = key === 'value' ? value : value;
            return {
                ...prev,
                [section]: updatedFields
            };
        });
    };

    const handleAddField = (section) => {
        setClientData((prev) => ({
            ...prev,
            [section]: [...(prev[section] || []), { name: '', value: '' }]
        }));
    };

    const handleRemoveField = (section, index) => {
        setClientData((prev) => {
            const updatedFields = [...prev[section]];
            updatedFields.splice(index, 1);
            return {
                ...prev,
                [section]: updatedFields
            };
        });
    };

    return (
        <div className="addUpdateAward-main">
            <div className="page-title">
                <h4>Update Salary Slip Details</h4>
                <div className="edit-btn">
                    <button className="custom-btn" onClick={() => navigate(-1)}>
                        {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "Cancel"}
                    </button>
                    <button className="custom-btn" onClick={handleUpdateSalarySlip}>
                        {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "Save"}
                    </button>
                </div>
            </div>
            <div className="content-part">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="left-part">
                            <div className="custom-row">
                                <div className='add-award-detail'>
                                    {/* Basic Information */}
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <h5 style={{ marginBottom: '20px', color: '#5757fe' }}>Basic Information</h5>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <h6 className='label'>Transaction ID</h6>
                                                <input
                                                    type="text"
                                                    className="input-css"
                                                    name='transaction_id'
                                                    value={clientData?.transaction_id}
                                                    placeholder="Enter Transaction ID"
                                                    onChange={(e) => handleInputChange('transaction_id', e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <h6 className='label'>Employee Name</h6>
                                                <input
                                                    type="text"
                                                    className="input-css"
                                                    name='name'
                                                    value={clientData?.name}
                                                    placeholder="Enter Employee Name"
                                                    onChange={(e) => handleInputChange('name', e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-3">
                                            <div className="input-group">
                                                <h6 className='label'>Pay Period Month</h6>
                                                <Select
                                                    styles={customStyle}
                                                    placeholder="Select Month"
                                                    value={clientData?.pay_period_month}
                                                    options={Month}
                                                    onChange={(selectedOption) => handleInputChange('pay_period_month', selectedOption)}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-3">
                                            <div className="input-group">
                                                <h6 className='label'>Pay Period Year</h6>
                                                <Select
                                                    styles={customStyle}
                                                    placeholder="Select Year"
                                                    value={clientData?.pay_period_year}
                                                    options={Year}
                                                    onChange={(selectedOption) => handleInputChange('pay_period_year', selectedOption)}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="input-group" style={{ position: 'relative' }}>
                                                <h6 className="label">Pay Date</h6>
                                                <DatePicker
                                                    styles={customStyle}
                                                    placeholderText="Select Date"
                                                    selected={clientData.pay_date ? new Date(clientData.pay_date) : null}
                                                    dateFormat="dd-MM-yyyy"
                                                    onChange={(date) => {
                                                        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                                                            .toISOString()
                                                            .split('T')[0];
                                                        handleInputChange('pay_date', localDate);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <h6 className='label'>Leave Deduction</h6>
                                                <input
                                                    type="number"
                                                    className="input-css"
                                                    name='leave'
                                                    value={clientData?.leave}
                                                    placeholder="Enter Leave Deduction"
                                                    onChange={(e) => handleInputChange('leave', e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <h6 className='label'>Working Days</h6>
                                                <input
                                                    type="number"
                                                    className="input-css"
                                                    name='day'
                                                    value={clientData?.day}
                                                    placeholder="Enter Working Days"
                                                    onChange={(e) => handleInputChange('day', e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <h6 className='label'>Loss Pay Days</h6>
                                                <input
                                                    type="number"
                                                    className="input-css"
                                                    name='loss_pay_day'
                                                    value={clientData?.loss_pay_day}
                                                    placeholder="Enter Loss Pay Days"
                                                    onChange={(e) => handleInputChange('loss_pay_day', e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Earnings Section */}
                                    <div className="row" style={{ marginTop: '30px' }}>
                                        <div className='col-md-6'>
                                            <div className="">
                                                <h5 style={{ marginBottom: '20px', color: '#5757fe' }}>Earnings</h5>
                                            </div>
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <td>Basic Salary</td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="input-css"
                                                                name='basic_salary'
                                                                value={clientData?.basic_salary}
                                                                placeholder="Enter Basic Salary"
                                                                onChange={(e) => handleInputChange('basic_salary', e.target.value)}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>House Rent Allowance</td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="input-css"
                                                                name='house_rent_allowance'
                                                                value={clientData?.house_rent_allowance}
                                                                placeholder="Enter HRA"
                                                                onChange={(e) => handleInputChange('house_rent_allowance', e.target.value)}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>DA (Dearness Allowance)</td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="input-css"
                                                                name='da'
                                                                value={clientData?.da}
                                                                placeholder="Enter DA"
                                                                onChange={(e) => handleInputChange('da', e.target.value)}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>MA (Medical Allowance)</td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="input-css"
                                                                name='ma'
                                                                value={clientData?.ma}
                                                                placeholder="Enter MA"
                                                                onChange={(e) => handleInputChange('ma', e.target.value)}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Special Allowance</td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="input-css"
                                                                name='special_allowance'
                                                                value={clientData?.special_allowance}
                                                                placeholder="Enter Special Allowance"
                                                                onChange={(e) => handleInputChange('special_allowance', e.target.value)}
                                                            />
                                                        </td>
                                                    </tr>
                                                    {(clientData.extraEarnings || []).map((field, index) => (
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="input-css"
                                                                    value={field.name}
                                                                    placeholder="Enter Field Name"
                                                                    onChange={(e) => handleExtraChange('extraEarnings', index, 'name', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className='d-flex align-items-center'>
                                                                <input
                                                                    type="number"
                                                                    className="input-css"
                                                                    value={field.value}
                                                                    placeholder="Enter Amount"
                                                                    onChange={(e) => handleExtraChange('extraEarnings', index, 'value', e.target.value)}
                                                                />
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm text-danger"
                                                                    onClick={() => handleRemoveField('extraEarnings', index)}
                                                                >
                                                                    <MdOutlineRemoveCircleOutline size={20} />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            <div className="">
                                                <div className="input-group" style={{ marginTop: '10px' }}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-primary btn-sm flex align-items-center"
                                                        onClick={() => handleAddField('extraEarnings')}
                                                    >
                                                        <IoMdAddCircleOutline size={18} /> Add Earning Field
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="">
                                                <div className="input-group" style={{ textAlign: 'right', marginTop: '10px' }}>
                                                    <h6 style={{ color: '#5757fe', fontSize: '16px' }}>
                                                        Total Earnings: ₹{calculateEarnings().toFixed(2)}
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>


                                        {/* Deductions Section */}
                                        <div className="col-md-6" style={{ marginTop: '30px' }}>
                                            <div className="col-lg-12">
                                                <h5 style={{ marginBottom: '20px', color: '#5757fe' }}>Deductions</h5>
                                            </div>

                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <td>Income Tax</td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="input-css"
                                                                name='incomeTax'
                                                                value={clientData?.incomeTax}
                                                                placeholder="Enter Income Tax"
                                                                onChange={(e) => handleInputChange('incomeTax', e.target.value)}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Provident Fund</td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="input-css"
                                                                name='providentFund'
                                                                value={clientData?.providentFund}
                                                                placeholder="Enter PF"
                                                                onChange={(e) => handleInputChange('providentFund', e.target.value)}
                                                            />
                                                        </td>
                                                    </tr>
                                                    {(clientData.extraDeductions || []).map((field, index) => (
                                                        <tr>
                                                            <td><input
                                                                type="text"
                                                                className="input-css"
                                                                value={field.name}
                                                                placeholder="Enter Field Name"
                                                                onChange={(e) => handleExtraChange('extraDeductions', index, 'name', e.target.value)}
                                                            /></td>
                                                            <td className='d-flex align-items-center'>

                                                                <input
                                                                    type="number"
                                                                    className="input-css"
                                                                    value={field.value}
                                                                    placeholder="Enter Amount"
                                                                    onChange={(e) => handleExtraChange('extraDeductions', index, 'value', e.target.value)}
                                                                />
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm text-danger"
                                                                    onClick={() => handleRemoveField('extraDeductions', index)}
                                                                >
                                                                    <MdOutlineRemoveCircleOutline size={20} />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            <div className="col-lg-12">
                                                <div className="input-group" style={{ marginTop: '10px' }}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-primary btn-sm flex align-items-center"
                                                        onClick={() => handleAddField('extraDeductions')}
                                                    >
                                                        <IoMdAddCircleOutline size={18} /> Add Deduction Field
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="col-lg-12">
                                                <div className="input-group" style={{ textAlign: 'right', marginTop: '10px' }}>
                                                    <h6 style={{ color: '#dc3545', fontSize: '16px' }}>
                                                        Total Deductions: ₹{calculateDeductions().toFixed(2)}
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Net Pay Summary */}
                                    <div className="row" style={{ marginTop: '30px' }}>
                                        <div className="col-lg-12">
                                            <div className="input-group" style={{
                                                textAlign: 'center',
                                                padding: '20px',
                                                backgroundColor: '#f8f9fa',
                                                border: '2px solid #5757fe',
                                                borderRadius: '8px'
                                            }}>
                                                <h5 style={{ color: '#5757fe', fontSize: '20px', margin: '0' }}>
                                                    Net Pay: ₹{calculateNetPay().toFixed(2)}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        loading: state.salaryReducer.loading,
        user: state.authenticationReducer.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSalarySlip: (id, data) => {
            dispatch(updateSalarySlip(id, data));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditEmpSalarySlips);